import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Form,
  Select,
  Divider,
} from 'antd';
import {
  fetchFileReferences,
} from 'src/features/storage/storageSlice';
import { transformFiles, particleEffectOptions, } from 'src/helpers';
/** type imports */
import type { AppDispatch } from 'src/app/store';
import type { RootState } from 'src/app/rootReducer';
import type { FormInstance } from 'antd/es/form';
import type { FormikErrors } from 'formik';
import type {
  PulleyNode,
  FormItemProps,
} from 'types';


interface Props {
  nodeDefinition: Partial<PulleyNode>;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => any;
  handleChange: (eventOrPath: string | React.ChangeEvent<any>) => void | ((eventOrTextValue: string | React.ChangeEvent<any>) => void);
  handleBlur: (eventOrString: any) => void | ((e: any) => void);
  form: FormInstance;
  isSubmitting: boolean;
  errors: FormikErrors<{ id: string; nodeDefinition: Partial<PulleyNode>; }>;
  setErrors: (errors: FormikErrors<{ id: string; nodeDefinition: Partial<PulleyNode>; }>) => void;
}

const PulleyNodeFormBody: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  // const {
  //   tagDefinitions,
  //   fetchingTagDefinitions,
  // } = useSelector((state: RootState) => state.tagDefinitionsState);

  const {
    fileReferences: {
      // imageFiles,
      videoFiles,
      audioFiles,
    },
    fetchingFileReferences,
  } = useSelector((state: RootState) => state.storageState);

  React.useEffect(() => {
    dispatch(fetchFileReferences());
  }, [dispatch]);

  const particleOptions = Object.entries(particleEffectOptions)
  .map(([particleKey, particleDisplay]) => ({ label: particleDisplay, value: particleKey }));

  const {
    nodeDefinition,
    // setFieldValue,
    // handleChange,
    // handleBlur,
    isSubmitting,
    errors,
    // form,
  } = props;

  const {
    startingVideo,
    botAudio,
    waitingVideo,
    afterVideo,
    particleEffect,
  } = nodeDefinition;


  type QuestionFormErrors = {
    [K in keyof PulleyNode]?: string;
  }

  // interface AnswerFormErrors {
  //   [answerDefKey: string]: string;
  // }

  function generateFormItemProps(itemName: keyof PulleyNode): FormItemProps {
    const hasError = itemName in errors;
    return {
      name: ['nodeDefinition', itemName],
      validateStatus: hasError ? 'error' : '',
      hasFeedback: hasError,
      help: hasError ? (errors as QuestionFormErrors)[itemName] : false,
    };
  }

  const audioOptions = transformFiles(audioFiles);
  // const imageOptions = transformFiles(imageFiles);
  const videoOptions = transformFiles(videoFiles);

  const audioPlaceholder = 'audio/example.mp3';
  // const imagePlaceholder = 'image/example.jpeg';
  const videoPlaceholder = 'video/example.mp4';
  if (Object.keys(errors).length) {
    console.log(errors);
  }

  return (
    <React.Fragment>
      <Divider>Pulley Configuration</Divider>
      <Form.Item
        {...generateFormItemProps('startingVideo')}
        label={'Starting Video File'}
      >
        <Select
          allowClear
          showSearch
          options={videoOptions}
          disabled={isSubmitting}
          loading={fetchingFileReferences}
          value={startingVideo}
          placeholder={videoPlaceholder}
        />
      </Form.Item>
      <Form.Item
        {...generateFormItemProps('botAudio')}
        label={'Bot Audio File'}
      >
        <Select
          allowClear
          showSearch
          options={audioOptions}
          disabled={isSubmitting}
          loading={fetchingFileReferences}
          value={botAudio}
          placeholder={audioPlaceholder}
        />
      </Form.Item>
      <Form.Item
        {...generateFormItemProps('waitingVideo')}
        label={'Waiting Video File'}
      >
        <Select
          allowClear
          showSearch
          options={videoOptions}
          disabled={isSubmitting}
          loading={fetchingFileReferences}
          value={waitingVideo}
          placeholder={videoPlaceholder}
        />
      </Form.Item>
      <Form.Item
        {...generateFormItemProps('afterVideo')}
        label={'After Video File'}
      >
        <Select
          allowClear
          showSearch
          options={videoOptions}
          disabled={isSubmitting}
          loading={fetchingFileReferences}
          value={afterVideo}
          placeholder={videoPlaceholder}
        />
      </Form.Item>
      <Form.Item
        {...generateFormItemProps('particleEffect')}
        label={'Particle Effect'}
      >
        <Select
          allowClear
          options={particleOptions}
          disabled={isSubmitting}
          value={particleEffect}
          placeholder='Fire'
        />
      </Form.Item>
    </React.Fragment>
  );
};

export default PulleyNodeFormBody;